import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const AppointmentError = (_param)=> {
    var { className , labels , buttonUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "buttonUrl"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-error', className)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "appointment-error__icon-wrapper"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "calendar-time",
        height: 32,
        width: 32
    })), /*#__PURE__*/ React.createElement(Heading, {
        component: "h1",
        variant: "medium"
    }, labels.title), /*#__PURE__*/ React.createElement(Text, {
        className: "appointment-error__description"
    }, labels.description), /*#__PURE__*/ React.createElement(Button, {
        caption: labels.buttonCaption,
        href: buttonUrl
    }), /*#__PURE__*/ React.createElement("a", {
        className: "appointment-error__go-to-home-link",
        href: "/"
    }, labels.goToHome));
};

export { AppointmentError as default };
//# sourceMappingURL=AppointmentError.js.map
